import { useNavigate, useParams } from 'react-router-dom'
import styles from '../styles/containers.module.css'
import { Spinner } from '@verisart/shared'
import Claim from '../components/organisms/Claim'
import useClaimMint from '../lib/hooks/useClaimMint'
import useGetDropDetails from '../lib/hooks/useGetDropDetails'
import useClaimMintSignable from 'src/lib/hooks/useClaimSignable'
import assert from 'assert'
import TopBar from 'src/components/organisms/TopBar'
import t from '../lib/translation'
import { useEffect, useState } from 'react'
import { useAccount } from 'wagmi'
import { useConnectWallet } from '@verisart/nft/src'
import MoveWalletDialog from 'src/components/organisms/MoveWalletDialog'

const MintPage = () => {
  const navigate = useNavigate()
  const { id } = useParams<'id'>()
  const [isPolling, setIsPolling] = useState(false)
  const { assetDetails, isLoading: isDropDetailsLoading } = useGetDropDetails(
    id as string,
    isPolling
  )

  const { address: activeWallet, connector } = useAccount()
  const {
    connect: connectWallet,
    connectMagic: connectMagicWallet,
    disconnect,
    connecting,
    showMagic,
  } = useConnectWallet()

  const {
    claimMint,
    claimed: claimedMint,
    error: claimMintError,
    loading: claimingMint,
  } = useClaimMint(
    id as string,
    activeWallet,
    assetDetails?.blockchain,
    connector?.id
  )

  const {
    claimSignable,
    claimed: claimedSignable,
    error: claimSignableError,
    loading: claimingSignable,
  } = useClaimMintSignable()

  const handleClaim = () => {
    if (assetDetails?.signedMinting) {
      assert(activeWallet, 'activeWallet connected wrongly')
      claimSignable(id as string, activeWallet)
    } else {
      claimMint()
    }
  }

  useEffect(() => {
    if (assetDetails !== undefined && assetDetails.completed === false) {
      setIsPolling(true)
    } else {
      setIsPolling(false)
    }
  }, [assetDetails])

  return (
    <>
      <div
        className={`ver-w-full ver-flex ver-flex-col ver-mb-20 ${styles.container}`}
      >
        <TopBar blockchain={assetDetails?.blockchain} />
        <div className="ver-flex ver-flex-grow ver-items-center ver-justify-center">
          {isDropDetailsLoading ? (
            <Spinner />
          ) : (
            <Claim
              activeWallet={activeWallet}
              assetDetails={assetDetails}
              claimed={assetDetails?.claimed || claimedMint || claimedSignable}
              loading={connecting || claimingMint || claimingSignable}
              claimError={claimMintError || claimSignableError}
              onBack={() => {
                const redirectLink = t.claim.button.redirectLink

                if (redirectLink === '/apps/verisart') {
                  navigate('/')
                } else {
                  window.open(
                    redirectLink
                      .replaceAll(
                        '$contractAddress',
                        assetDetails?.contractAddress || ''
                      )
                      .replaceAll('$tokenId', assetDetails?.tokenIds?.[0] ?? '')
                      .replaceAll(
                        '$blockchain',
                        assetDetails?.blockchain || ''
                      ),
                    '_blank'
                  )
                }
              }}
              onConnect={connectWallet}
              onConnectMagic={connectMagicWallet}
              showMagicWallet={showMagic}
              onClaim={handleClaim}
              disconnect={disconnect}
            />
          )}
        </div>

        <MoveWalletDialog />
      </div>
    </>
  )
}

export default MintPage
